"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationTableSortColumn = exports.UserTableSortColumn = exports.OrderTableSortColumn = exports.SortOrder = void 0;
exports.isValidSortColumn = isValidSortColumn;
exports.isValidSortOrder = isValidSortOrder;
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (exports.SortOrder = SortOrder = {}));
var OrderTableSortColumn;
(function (OrderTableSortColumn) {
    OrderTableSortColumn["BARCODE_ID"] = "barcodeId";
    OrderTableSortColumn["INSERTED"] = "inserted";
    OrderTableSortColumn["SUBMITTED"] = "submitted";
    OrderTableSortColumn["REGISTERED"] = "registered";
})(OrderTableSortColumn || (exports.OrderTableSortColumn = OrderTableSortColumn = {}));
var UserTableSortColumn;
(function (UserTableSortColumn) {
    UserTableSortColumn["INSERTED"] = "inserted";
    UserTableSortColumn["USER_NAME"] = "userName";
    UserTableSortColumn["ROLE"] = "role";
    UserTableSortColumn["FIRST_NAME"] = "firstName";
    UserTableSortColumn["LAST_NAME"] = "lastName";
    UserTableSortColumn["CLIENT_COMPANY_NAME"] = "clientCompanyName";
})(UserTableSortColumn || (exports.UserTableSortColumn = UserTableSortColumn = {}));
var OrganizationTableSortColumn;
(function (OrganizationTableSortColumn) {
    OrganizationTableSortColumn["INSERTED"] = "inserted";
    OrganizationTableSortColumn["CLIENT_COMPANY_NAME"] = "clientCompanyName";
})(OrganizationTableSortColumn || (exports.OrganizationTableSortColumn = OrganizationTableSortColumn = {}));
function isValidSortColumn(enumObj, value) {
    return Object.values(enumObj).includes(value);
}
function isValidSortOrder(order) {
    return Object.values(SortOrder).includes(order);
}
